module.exports = __webpack_public_path__ + "img/1F3AB.b06e0eaa.svg";